import CoreLayout from 'layouts/PageLayout/PageLayout';
import LoginRoute from './Login';
import ForgottenPassword from './ForgottenPassword';
import ForgottenPasswordSent from './ForgottenPasswordSent';
import DashboardRoute from './Dashboard';
import ConferenceProfileRoute from './ConferenceProfile';
import ConferenceApplyRoute from './ConferenceApply';
import ConferenceApplyPaymentRoute from './ConferenceApplyPayment';
import ConferenceApplyTransferRoute from './ConferenceApplyTransfer';
import ConferenceApplyPaymentCallbackRoute from './ConferenceApplyPaymentCallback';
import ConferenceApplyPaymentCallbackOtpRoute from './ConferenceApplyPaymentOTPCallback';
import ConferenceApplySzepKhCallback from './ConferenceApplySzepKhCallback';
import ConferenceApplyPaymentStatusRoute from './ConferenceApplyPaymentStatus';
import ConferenceApplyPaymentCashRoute from './ConferenceApplyCash';
import ConferenceApplyPaymentSzepRoute from './ConferenceApplySzep';
import RegistrationRoute from './Registration';
import AdminRoute from './Admin';
import InfosRoute from './Infos';
import InfoRoute from './InfoPage';
import ConferenceAdminProfile from './ConferenceAdminProfile';
import ConferenceApplications from './ConferenceApplications';
import AddConferenceRoute from './AddConference';
import EditConferenceRoute from './EditConference';
import ProfileChangePassword from './Profile/ChangePassword';
import BillingInfo from './Profile/BillingInfo';
import Page404 from './Page404';


export const createRoutes = store => ({
  path        : '/',
  component   : CoreLayout,
  indexRoute  : LoginRoute(store),
  childRoutes : [
    DashboardRoute(store),
    ConferenceProfileRoute(store),
    ConferenceApplyRoute(store),
    ConferenceApplyPaymentRoute(store),
    ConferenceApplyTransferRoute(store),
    ConferenceApplyPaymentCashRoute(store),
    ConferenceApplyPaymentSzepRoute(store),
    ConferenceApplyPaymentCallbackRoute(store),
    ConferenceApplyPaymentCallbackOtpRoute(store),
    ConferenceApplySzepKhCallback(store),
    ConferenceApplyPaymentStatusRoute(store),
    RegistrationRoute(store),
    AdminRoute(store),
    InfosRoute(store),
    InfoRoute(store),
    ConferenceAdminProfile(store),
    ConferenceApplications(store),
    AddConferenceRoute(store),
    EditConferenceRoute(store),
    ForgottenPassword(store),
    ForgottenPasswordSent(store),
    ProfileChangePassword(store),
    BillingInfo(store),
    Page404,
  ],
});

export default createRoutes;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/index.js